import * as React from "react";
import { NativeTileShowcaseRegionProps } from "./typings";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";

import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { SimpleContainerModel } from "components/flexComponents/SimpleContainer/typings";

export const NativeTileShowcaseRegion = (props: NativeTileShowcaseRegionProps) => {
  const blossomComponent = BlossomComponentFactory.get(props as BlossomComponentFactoryProps);
  const context = props.context;

  if (!blossomComponent) {
    return null;
  }

  const model = blossomComponent.model as SimpleContainerModel;
  const { mobileWidth, title, innerTitle, tabletWidth, desktopWidth } = model;
  const modules = blossomComponent.getBlossomComponents();

  if (
    title &&
    innerTitle &&
    modules &&
    modules.length > 0 &&
    modules.filter((module) => module.shouldRender()).length === 0
  ) {
    return null;
  }

  const headingClass =
    "uitk-type-display-700 all-t-padding-six all-b-padding-zero uitk-cell all-cell-1-1 all-l-padding-zero";

  const titleContent = (
    <>
      {title && <h2 className={headingClass}>{title}</h2>}
      {innerTitle && <h2 className={headingClass}>{innerTitle}</h2>}
    </>
  );

  const flexContentDesktop = (
    <>
      {titleContent}
      <UitkLayoutFlex direction="row" wrap="nowrap" className="NativeTileShowcaseRegion">
        <BlossomComponents blossomComponent={blossomComponent} context={context} />
      </UitkLayoutFlex>
    </>
  );

  const flexContentNonDesktop = (
    <>
      {titleContent}
      <UitkLayoutFlex direction="column" space="six" wrap="wrap">
        <BlossomComponents blossomComponent={blossomComponent} context={context} />
      </UitkLayoutFlex>
    </>
  );

  return (
    <Viewport>
      {mobileWidth === "hidden" ? <ViewSmall /> : <ViewSmall>{flexContentNonDesktop}</ViewSmall>}

      {tabletWidth === "hidden" ? <ViewMedium /> : <ViewMedium>{flexContentNonDesktop}</ViewMedium>}

      {desktopWidth === "hidden" ? <ViewLarge /> : <ViewLarge>{flexContentDesktop}</ViewLarge>}
    </Viewport>
  );
};

export default NativeTileShowcaseRegion;
